// Where the in-app viewer (FilePreviewModal) fetches a document from.
//
//   - a file stored in Ops (/api/uploads/...) is fetched as it is;
//   - a SharePoint or OneDrive link on the company tenant is fetched through
//     /api/document-preview/:kind/:id, which reads it with the app's Graph
//     token for somebody who may see the record it sits on;
//   - anything else (another website, a link with no record) is not previewed,
//     and the link opens as it always has.
//
// `kind` names the record, as the server's preview route does: sow,
// sow-index, bid, bid-library, person.

export const TENANT_HOST = /^altonvalley(-my)?\.sharepoint\.com$/i;

export function isSharePointLink(url) {
  try {
    const u = new URL(String(url || ''));
    return u.protocol === 'https:' && TENANT_HOST.test(u.hostname);
  } catch { return false; }
}

const lastSegment = (url) => {
  try { return decodeURIComponent(new URL(url, 'https://ops.local').pathname.split('/').pop() || ''); }
  catch { return ''; }
};

/**
 * What to hand the viewer for a document, or null to open its link instead.
 * Returns { url, filename, openUrl }: openUrl is the SharePoint original, for
 * the viewer's "Open in SharePoint" button.
 */
export function previewTarget({ kind, id, url, filename, title }) {
  if (!url) return null;
  if (String(url).startsWith('/api/uploads/')) {
    return { url, filename: filename || lastSegment(url) || title || 'document', openUrl: null };
  }
  if (kind && id && isSharePointLink(url)) {
    // A sharing link rarely ends in the file's name; the server's X-Filename says.
    const named = filename || (/\.[a-z0-9]{2,5}$/i.test(lastSegment(url)) ? lastSegment(url) : '') || title || 'document';
    return { url: `/api/document-preview/${encodeURIComponent(kind)}/${encodeURIComponent(id)}`, filename: named, openUrl: url };
  }
  return null;
}
